import { ChangeEvent } from 'react';
import { useThemeContext } from 'context/ThemeContext/ThemeContext';

type Props = {
  options: string[];
  name: string;
  defaultValue?: string;
  onChange: (value: string, e: ChangeEvent<HTMLInputElement>) => void;
};

const RadioButtons = (props: Props) => {
  const { options, defaultValue, onChange, name } = props;
  const { brandTheme } = useThemeContext();

  return (
    <div
      role='radiogroup'
      aria-labelledby='radio-buttons-group'
      className='flex flex-col'
    >
      {options.map((value) => {
        const isSelected = value === defaultValue;
        return (
          <label
            key={value}
            className='w-full flex items-start mx-0 my-1.5 cursor-pointer'
          >
            <input
              type='radio'
              name={name}
              value={value}
              checked={isSelected}
              onChange={(event) => onChange(event.target.value, event)}
              className='cursor-pointer'
              style={{
                width: '16px',
                height: '24px',
                marginRight: '12px',
                accentColor: isSelected ? brandTheme : '#414149',
              }}
            />
            <span className='text-sm leading-5 font-semibold pt-0.5'>
              {value}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default RadioButtons;
